import { Button } from "@mui/material";
import { useMemo } from "react";
import { useLoaderData, useNavigate, useLocation } from "react-router-dom";

import { DASHBOARD_KEYS } from "../../../../../../globalConstants";
import { inject } from "../../../../../../lib/itn-ui-kit/services/service-container";
import { useHistoryNavigate } from "../../../../../hooks/useHistoryNavigate";
import useService from "../../../../../hooks/useService";
import { resolveReturnTarget } from "../../../../global/returnTo";
import HNSColors from "../../../../ui library/HNSColors";
import { getQuestionByModule } from "../modules/DynamicSection/helpers/functions";

const ActionButtons = ({ enableSave, formData, handleSubmit }) => {
  const landingService = inject("landing-service");
  const formService = useService("repositories/follow-ups-form-submit-repository");
  const { followUp, followUpId } = useLoaderData();
  const { navigationHistoryService } = useHistoryNavigate();
  const navigate = useNavigate();
  const location = useLocation();

  const dueDate = useMemo(() => {
    const dateQuestion = getQuestionByModule(followUp, "action_item_date");
    const dateFormData = formData?.question_1?.due_date;
    return dateFormData ?? dateQuestion?.data?.due_date ?? null;
  }, [followUp, formData]);

  async function handleComplete() {
    const saved = await handleSubmit();
    if (!saved) {
      return;
    }

    try {
      await formService.patch(followUpId, {
        status: "done",
        due_date: dueDate,
      });
      const prevRoute = navigationHistoryService.get(DASHBOARD_KEYS.dashboardId);
      const accessibleRoute = landingService.PriorityAccessibleRoute;
      const target = resolveReturnTarget(location.state?.returnTo, prevRoute ?? accessibleRoute);
      navigate(target, { replace: true });
    } catch (error) {
      console.error("Error marking follow-up as complete:", error);
    }
  }

  return (
    <div className="mb-1 flex w-full gap-4">
      <Button
        sx={{
          background: HNSColors.secondary[500],
          "&:hover": {
            background: HNSColors.secondary[600],
          },
        }}
        disabled={!enableSave}
        className="h-[50px] min-h-[50px] w-[240px] min-w-[240px] rounded-full px-[18px] py-[10px] text-sm normal-case transition"
        variant="contained"
        disableElevation
        type="submit"
      >
        Save
      </Button>
      <Button
        sx={{
          color: HNSColors.secondary[500],
          border: `1px solid ${HNSColors.secondary[500]}`,
          "&:hover": {
            background: HNSColors.secondary[900],
            border: `1px solid ${HNSColors.secondary[500]}`,
          },
        }}
        onClick={handleComplete}
        className="h-[50px] min-h-[50px] w-[240px] min-w-[240px] rounded-full bg-white px-[18px] py-[10px] text-center text-sm font-normal normal-case leading-none transition"
        variant="outlined"
        disableElevation
        disabled={!dueDate}
      >
        Mark Complete
      </Button>
    </div>
  );
};

export default ActionButtons;
